<!-- Single router-outlet: toggling the shell never re-mounts the routed page. -->
<div
  [class]="shellHidden() === false ? 'flex flex-col min-h-screen antialiased selection:bg-indigo-100 selection:text-indigo-700 dark:selection:bg-indigo-900 dark:selection:text-indigo-300 bg-white dark:bg-slate-950 text-slate-600 dark:text-slate-300 transition-colors duration-300' : ''"
  [style.font-family]="shellHidden() === false ? 'Geist, Inter, sans-serif' : null">
  @if (shellHidden() === false) {
    <app-navbar></app-navbar>
  }
  <div [attr.role]="shellHidden() === false ? 'main' : null" [class.flex-grow]="shellHidden() === false">
    <router-outlet></router-outlet>
  </div>
  @if (shellHidden() === false) {
    <app-footer></app-footer>
  }
</div>
<!-- TEMPORARY: brand concept preview on v3 pages. Remove with src/styles/brand-preview.scss. -->
@if (shellHidden() === true) {
  <app-brand-switcher />
}
